import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import type { RootReducerStateT } from 'app/reducers/rootReducer';
import { DEFAULT_SCHEDULE } from 'components/powerFlowShared/components/modals/openinghours/constants';

import {
  createOpeningHoursModal,
  OpeningHoursModalFormValues,
  Props as OpeningHoursProps,
  OwnProps,
} from '../../components/modals/openingHours';

const FORM_NAME = 'openingHoursForm';

export type StateProps = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (
  _state: RootReducerStateT,
  { node: { payload } }: OwnProps,
) => {
  const initialValues = {
    schedule: payload?.schedule || DEFAULT_SCHEDULE,
    timezone: payload?.timezone || moment.tz.guess(true),
  };

  return {
    initialValues,
  };
};

export const createOpeningHoursModalContainer = (
  isDeprecated: boolean,
): ReturnType<typeof createOpeningHoursModalContainer> =>
  connect(mapStateToProps)(
    reduxForm<OpeningHoursModalFormValues, OpeningHoursProps>({
      enableReinitialize: true,
      form: FORM_NAME,
      touchOnBlur: false,
      validate: () => ({}),
    })(createOpeningHoursModal(isDeprecated)),
  );
